import React, { useEffect } from "react";
import Bankingabout from "./Bankingabout";
import Bankingservices from "./Bankingservices";
import Bankingexplore from "./Bankingexplore";
import Bankingdigital from "./Bankingdigital";
import Bankingbanner from "./Bankingbanner";

const Banking = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        backgroundImage:
          "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <Bankingbanner/>
        <Bankingabout/>
        <Bankingservices/>

        {/* <Bankingexplore/> */}
        <Bankingdigital/>
      </div>
    </div>
  );
};

export default Banking;
